"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.exportCriticalActions = void 0;

var _reduxObservable = require("redux-observable");

var _actions = require("./actions");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _API = _interopRequireDefault(require("./API"));

var _requestSelectors = require("./requestSelectors");

var _RequestStatusTypeFilters = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypeFilters"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var exportCriticalActions = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.exportCriticalActions,
  initiatingActionType: _actions.CriticalActionsApiActionTypes.EXPORT,
  requestStatusSelector: _requestSelectors.getExportCriticalActionsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.ExportCriticalActions
}));
exports.exportCriticalActions = exportCriticalActions;

var _default = (0, _reduxObservable.combineEpics)(exportCriticalActions);

exports.default = _default;